<div class="table-responsive">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="d-flex align-items-center justify-content-between mt-3 mb-3" style="padding-left: 1%;">
            <h2 style="margin-bottom: 0;">Field Information</h2>
            <div class="button-items d-flex align-items-center" style="gap: 8px;">
              <button class="btn btn-primary btn-sm" (click)="loadFieldRecords(lastTableLazyLoadEvent)"
                pTooltip="Refresh table" appActionTooltip><i class="mdi mdi-reload"></i></button>
                <button class="btn btn-primary btn-sm" (click)="dt.clear()"
                pTooltip="Clear all column filters and sorting" appActionTooltip>Clear <i
                class="mdi mdi-filter-remove"></i></button>
              </div>
            </div>
          </div>
        </div>
        <p-table [lazy]="true" #dt [columns]="cols" (onLazyLoad)="loadFieldRecords($event)" [value]="fieldRecords"
          dataKey="id" styleClass="p-datatable-tasks" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10,25,50]" [loading]="loading" responsiveLayout="scroll" [paginator]="true"
          [autoLayout]="true" [totalRecords]="totalRecords" paginatorDropdownAppendTo="body" scrollable="true"
          scrollHeight="600px" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [filterDelay]="0">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th>Actions</th>
              @for (col of columns; track col) {
                <th pSortableColumn="{{col.field}}">
                  <div class="flex align-items-center">
                    {{ col.header }}
                    @if (col.isSortable) {
                      <p-sortIcon [field]="col.field"></p-sortIcon>
                    }
                    @if (col.isFilterable) {
                      <p-columnFilter matchMode="contains" [showOperator]="false"
                      [showAddButton]="false" [field]="col.field" display="menu"></p-columnFilter>
                    }
                  </div>
                </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-field let-columns="columns">
            <tr>
              <td>
                <div class="flex gap-2">
                  <button class="btn btn-info btn-sm" pTooltip="View field information" appActionTooltip (click)="viewField(field)"
                    role="button"><i class="mdi mdi-eye"></i></button>
                    <button class="btn btn-warning btn-sm" pTooltip="Edit field information" appActionTooltip (click)="editField(field)"
                      role="button"><i class="mdi mdi-pencil"></i></button>
                    </div>
                  </td>
                  @for (col of columns; track col) {
                    <td>
                      {{ field[col.field] }}
                    </td>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="cols.length + 1" class="text-center py-4">
                    No field records found.
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>

      <p-dialog [resizable]="false" [draggable]="false" [(visible)]="fieldDialog" (onHide)="closeDialog()"
        [style]="{width: '60%'}" [header]="title" [modal]="true" styleClass="p-fluid">
        <ng-template pTemplate="content">
          <form [formGroup]="fieldForm">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="mb-3">
                      <label class="form-label">Screen Name</label>
                      <input class="form-control" type="text" formControlName="gridName" disabled>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="mb-3">
                      <label class="form-label">Field Name</label>
                      <input class="form-control" type="text" formControlName="fieldName" disabled>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="mb-3">
                      <label class="form-label">Show Information</label>
                      <select class="form-select" formControlName="showInformation" [disabled]="viewOnly">
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="mb-3">
                      <label class="form-label d-flex align-items-center">
                        Information Text
                        <info-tooltip [infoText]="fieldForm.get('informationText')?.value"></info-tooltip>
                      </label>
                      <textarea class="form-control" rows="3" formControlName="informationText"
                      [required]="showInformation?.value=='Yes'" [disabled]="viewOnly" appSpellCheck></textarea>
                      @if (submitted && showInformation?.value=='Yes' && !informationText?.value) {
                        <span class="text-danger"
                          >
                          Information Text is required when Show Information is enabled
                        </span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            @if (!viewOnly) {
              <div class="row">
                <div class="col-xl-12">
                  <div class="button-items" style="float: right;">
                    <span appActionTooltip [pTooltip]="btnLoading ? getUpdateDisabledReason() : 'Save changes'"
                      [actionDisabled]="btnLoading">
                      <button type="button" class="btn btn-primary" (click)="saveField()" [disabled]="btnLoading">
                        Update
                        @if (btnLoading) {
                          <i class="fa fa-spin fa-spinner"></i>
                        }
                      </button>
                    </span>
                    <button type="button" class="btn btn-secondary" (click)="closeDialog()"
                      pTooltip="Discard changes and close" appActionTooltip>Cancel</button>
                  </div>
                </div>
              </div>
            }
          </form>
        </ng-template>
      </p-dialog>
